let currentActivity = null

export const withRequestActivity = (activity, callback) => {
  const previous = currentActivity
  currentActivity = activity
  try {
    return callback()
  } finally {
    currentActivity = previous
  }
}
export const getRequestActivity = () => currentActivity

export const waitForRequestActivity = (activity) => new Promise((resolve) => {
  const unsubscribe = activity.subscribe(() => {
    if (!activity.isPending()) {
      unsubscribe()
      resolve()
    }
  })
  if (!activity.isPending()) {
    unsubscribe()
    resolve()
  }
})

export const createRequestActivity = () => {
  let pending = 0
  const listeners = new Set()
  return {
    isPending: () => pending > 0,
    subscribe: (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    begin: () => {
      pending += 1
      listeners.forEach((listener) => listener())
      let finished = false
      return () => {
        if (finished) return
        finished = true
        pending -= 1
        listeners.forEach((listener) => listener())
      }
    }
  }
}
